<template>
  <v-container v-if="showBlueBox || showCrlCreate" fluid class="promos-container">
    <v-layout class="promo" v-bind="promosContainerBinding">
      <v-flex
        v-if="showCrlCreate"
        sm12
        :md7="showBlueBox"
        :m12="!showBlueBox">
        <CreateList
          :hg-create-list="createList"
          :hg-eligible-reports="crlEligibleInspectionReports" />
      </v-flex>
      <v-flex
        v-if="showBlueBox && showCrlCreate"
        sm0
        md1
        shrink />
      <v-flex
        v-if="showBlueBox"
        sm12
        :md5="showCrlCreate"
        :m12="!showCrlCreate">
        <BlueBox :offer="displayBlueBoxOffer" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

import BlueBox from './BlueBox/BlueBox.vue';
import CreateList from './RequestList/CreateList.vue';

export default {
  components: {
    BlueBox,
    CreateList,
  },
  computed: {
    ...mapGetters('Inspection', [
      'crlEligibleInspectionReports',
      'inspectionReports',
      'inspectionRequestLists',
    ]),
    ...mapState('Inspection', {
      inspection: state => state.inspection,
    }),
    // @TODO disabled circa WEB-4080 pending a product decision
    // ...mapState('Offers', {
    //   blueBoxOffers: state => state.blueBoxOffers,
    // }),
    displayBlueBoxOffer() {
      return null;
      // @TODO disabled circa WEB-4080 pending a product decision
      //   return (this.blueBoxOffers
      //     && this.blueBoxOffers.payload
      //     && this.blueBoxOffers.payload.length > 0)
      //     ? this.blueBoxOffers.payload[0]
      //     : null;
    },
    // @TODO refactor consumer component `hg-create-list` to use individual props instead of object
    createList() {
      const output = {
        blocked: false,
        enableRequestList: false,
        homeInspectionReportCount: 0,
        requestListCount: 0,
      };

      if (!this.inspection) {
        return output;
      }

      const { inspection } = this;
      if (inspection.folderStatus) {
        output.blocked = inspection.folderStatus.blocked;
      }
      if (inspection.company && inspection.company.companyOptions) {
        output.enableRequestList = inspection.company.companyOptions.enableRequestList;
      }
      if (this.inspectionReports) {
        output.homeInspectionReportCount = this.inspectionReports.length;
      }
      if (this.inspectionRequestLists) {
        output.requestListCount = this.inspectionRequestLists.length;
      }

      return output;
    },
    promosContainerBinding() {
      return {
        column: !this.$vuetify.breakpoint.mdAndUp,
      };
    },
    showBlueBox() {
      return false;
      // @TODO disabled circa WEB-4080 pending a product decision
      // return (this.blueBoxOffers && this.blueBoxOffers.payload)
      //   ? this.blueBoxOffers.payload.length > 0
      //   : false;
    },
    showCrlCreate() {
      const {
        blocked,
        enableRequestList,
        homeInspectionReportCount,
        requestListCount,
      } = this.createList;

      const viewedCrlInspectionReports = this.crlEligibleInspectionReports
        .some(report => report.viewed);

      return homeInspectionReportCount > 0
        && blocked === false
        && enableRequestList === true
        && requestListCount === 0
        && viewedCrlInspectionReports;
    },
  },
};
</script>

<style lang="scss" scoped>
.promo {
  margin: 0 auto;
  position: relative;
  width: 90%;
}

@media all and (max-width: 655px) {
  .blue-box {
    margin-top: 10px;
  }

  .promo {
    top: 0;
    width: 100%;
  }
}
</style>
